export function inferAppParamFromAcs(acsUrl, appParamFromQuery = "") {
  if (appParamFromQuery) {
    return appParamFromQuery;
  }

  if (!acsUrl) {
    return "";
  }

  if (acsUrl.includes("atlassian")) {
    return "jira";
  }

  if (acsUrl.includes("splitc")) {
    return "splitc";
  }

  if (acsUrl.includes("nextqs")) {
    return "nextqs";
  }

  if (acsUrl.includes("freshservice") || acsUrl.includes("myfreshworks")) {
    return "freshservice";
  }

  return "";
}
